import axiosIns from '@/libs/axios'

const ROOT_URL = '/bots'

export default {
  namespaced: true,
  state: {
    dataList: [],
    metaData: {
      total: 0, page: 1, limit: 50, totalPages: 0,
    },
    detail: null,
    positions: [],
    trades: [],
    wallets: [],
    dataSave: { message: null, status: null },
  },
  getters: {
    dataList: s => s.dataList,
    metaData: s => s.metaData,
    detail: s => s.detail,
    positions: s => s.positions,
    trades: s => s.trades,
    wallets: s => s.wallets,
    dataSaveStatus: s => s.dataSave,
  },
  mutations: {
    SET_DATA_LIST(state, data) { state.dataList = data },
    SET_META_DATA(state, data) { state.metaData = data },
    SET_DETAIL(state, data) { state.detail = data },
    SET_POSITIONS(state, data) { state.positions = data },
    SET_TRADES(state, data) { state.trades = data },
    SET_WALLETS(state, data) { state.wallets = data },
    SET_DATA_SAVE(state, data) { state.dataSave = data },
  },
  actions: {
    getDataList({ commit }, params) {
      return axiosIns.post(ROOT_URL, params || {})
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_META_DATA', response.data.meta || {
            total: 0, page: 1, limit: 50, totalPages: 0,
          })
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'Bot listesi alınamadı.' })
        })
    },
    getDetail({ commit }, id) {
      return axiosIns.get(`${ROOT_URL}/${id}`)
        .then(response => commit('SET_DETAIL', response.data.data))
        .catch(error => { console.error(error); commit('SET_DETAIL', null) })
    },
    create({ commit, dispatch }, body) {
      return axiosIns.post(`${ROOT_URL}/create`, body)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: 'Bot oluşturuldu.' })
          dispatch('getDataList', {})
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Oluşturma başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    update({ commit, dispatch }, { id, body }) {
      return axiosIns.patch(`${ROOT_URL}/${id}`, body)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: 'Bot güncellendi.' })
          dispatch('getDataList', {})
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Güncelleme başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    remove({ commit, dispatch }, id) {
      return axiosIns.delete(`${ROOT_URL}/${id}`)
        .then(() => {
          commit('SET_DATA_SAVE', { status: true, message: 'Bot silindi.' })
          dispatch('getDataList', {})
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'Silme başarısız.' })
        })
    },
    start({ commit, dispatch }, id) {
      return axiosIns.post(`${ROOT_URL}/${id}/start`)
        .then(() => {
          commit('SET_DATA_SAVE', { status: true, message: 'Bot başlatıldı.' })
          dispatch('getDataList', {})
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Başlatma başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
        })
    },
    stop({ commit, dispatch }, id) {
      return axiosIns.post(`${ROOT_URL}/${id}/stop`)
        .then(() => {
          commit('SET_DATA_SAVE', { status: true, message: 'Bot durduruldu.' })
          dispatch('getDataList', {})
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'Durdurma başarısız.' })
        })
    },
    pause({ commit, dispatch }, id) {
      return axiosIns.post(`${ROOT_URL}/${id}/pause`)
        .then(() => {
          commit('SET_DATA_SAVE', { status: true, message: 'Bot duraklatıldı.' })
          dispatch('getDataList', {})
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'Duraklatma başarısız.' })
        })
    },
    getPositions({ commit }, { id, openOnly = false }) {
      return axiosIns.get(`${ROOT_URL}/${id}/positions`, { params: { openOnly } })
        .then(response => commit('SET_POSITIONS', response.data.data))
        .catch(error => { console.error(error); commit('SET_POSITIONS', []) })
    },
    getTrades({ commit }, { id, limit = 100 }) {
      return axiosIns.get(`${ROOT_URL}/${id}/trades`, { params: { limit } })
        .then(response => commit('SET_TRADES', response.data.data))
        .catch(error => { console.error(error); commit('SET_TRADES', []) })
    },
    getWallets({ commit }, { id, limit = 100 }) {
      return axiosIns.get(`${ROOT_URL}/${id}/wallets`, { params: { limit } })
        .then(response => commit('SET_WALLETS', response.data.data))
        .catch(error => { console.error(error); commit('SET_WALLETS', []) })
    },
    closePosition({ commit, dispatch }, { id, positionId }) {
      return axiosIns.post(`${ROOT_URL}/${id}/positions/${positionId}/close`)
        .then(() => {
          commit('SET_DATA_SAVE', { status: true, message: 'Pozisyon kapatıldı.' })
          dispatch('getPositions', { id })
          dispatch('getTrades', { id, limit: 100 })
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Pozisyon kapatılamadı.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
        })
    },
    updatePositionStops({ commit, dispatch }, { id, positionId, body }) {
      return axiosIns.patch(`${ROOT_URL}/${id}/positions/${positionId}`, body)
        .then(() => {
          commit('SET_DATA_SAVE', { status: true, message: 'Pozisyon güncellendi.' })
          dispatch('getPositions', { id })
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Güncelleme başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
        })
    },
  },
}
